/* eslint-disable no-fallthrough */
import { cmActionTypes } from '../../actions/settings/cmActions';

const CMReducers = (state = {}, action) => {
  switch (action.type) {
  case cmActionTypes.GET_CM.LOADING: {
    const { getCMLoading, entityType } = action;

    if (entityType === 'PRODUCTS') {
      return {
        ...state,
        getcustomMessageProductsLoading: getCMLoading,
      };
    }
    if (entityType === 'VENDORS') {
      return {
        ...state,
        getcustomMessageVendorsLoading: getCMLoading,
      };
    }
    if (entityType === 'DELIVERY_CHALLAN') {
      return {
        ...state,
        getcustomMessageDeliveryChallanLoading: getCMLoading,
      };
    }
    if (entityType === 'STOCK ADJUSTMENT') {
      return {
        ...state,
        getcustomMessageStockAdjustmentLoading: getCMLoading,
      };
    }
    if (entityType === 'BILL_OF_MATERIAL') {
      return {
        ...state,
        getcustomMessageBillOfMaterialLoading: getCMLoading,
      };
    }
    if (entityType === 'STOCK_TRANSFER') {
      return {
        ...state,
        getcustomMessageStockTransferLoading: getCMLoading,
      };
    }
    if (entityType === 'CUSTOMER_PAYMENT') {
      return {
        ...state,
        getcustomMessagecustomerPaymentLoading: getCMLoading,
      };
    }

    if (entityType === 'VENDOR_PAYOUT') {
      return {
        ...state,
        getcustomMessageVendorPayoutLoading: getCMLoading,
      };
    }
    if (entityType === 'SALES_ORDER') {
      return {
        ...state,
        getcustomMessageSalesOrderLoading: getCMLoading,
      };
    }
    if (entityType === 'MANUFACTURING_ORDER') {
      return {
        ...state,
        getcustomMessageManufacturingOrderLoading: getCMLoading,
      };
    }
    if (entityType === 'DEBIT_NOTE') {
      return {
        ...state,
        getcustomMessageDebitNoteLoading: getCMLoading,
      };
    }
    if (entityType === 'GOOD_RECEIVING_NOTES') {
      return {
        ...state,
        getcustomMessageGoodReceivingNotesLoading: getCMLoading,
      };
    }
    if (entityType === 'PURCHASE_ORDERS') {
      return {
        ...state,
        getcustomMessagePurchaseOrdersLoading: getCMLoading,
      };
    }
    if (entityType === 'PURCHASE_REQUEST') {
      return {
        ...state,
        getcustomMessagePurchaseRequestLoading: getCMLoading,
      };
    }
    if (entityType === 'CREDIT_NOTE') {
      return {
        ...state,
        getcustomMessageCreditNoteLoading: getCMLoading,
      };
    }
    if (entityType === 'CUSTOMERS') {
      return {
        ...state,
        getcustomMessagecustomersLoading: getCMLoading,
      };
    }
    if (entityType === 'INVOICE') {
      return {
        ...state,
        getcustomMessageInvoiceLoading: getCMLoading,
      };
    }
  }

  // eslint-disable-next-line no-fallthrough
  case cmActionTypes.GET_CM.SUCCESS: {
    const { customMessages, entityType } = action;

    if (entityType === 'PRODUCTS') {
      return {
        ...state,
        customMessageProducts: customMessages,
      };
    }
    if (entityType === 'VENDORS') {
      return {
        ...state,
        customMessageVendors: customMessages,
      };
    }
    if (entityType === 'DELIVERY_CHALLAN') {
      return {
        ...state,
        customMessageDeliveryChallan: customMessages,
      };
    }
    if (entityType === 'STOCK ADJUSTMENT') {
      return {
        ...state,
        customMessageStockAdjustment: customMessages,
      };
    }
    if (entityType === 'BILL_OF_MATERIAL') {
      return {
        ...state,
        customMessageBillOfMaterial: customMessages,
      };
    }
    if (entityType === 'STOCK_TRANSFER') {
      return {
        ...state,
        customMessageStockTransfer: customMessages,
      };
    }
    if (entityType === 'CUSTOMERS_PAYMENT') {
      return {
        ...state,
        customMessagecustomerPayment: customMessages,
      };
    }
    if (entityType === 'VENDOR_PAYOUT') {
      return {
        ...state,
        customMessageVendorPayout: customMessages,
      };
    }
    if (entityType === 'SALES_ORDER') {
      return {
        ...state,
        customMessageSalesOrder: customMessages,
      };
    }
    if (entityType === 'MANUFACTURING_ORDER') {
      return {
        ...state,
        customMessageManufacturingOrder: customMessages,
      };
    }
    if (entityType === 'DEBIT_NOTE') {
      return {
        ...state,
        customMessageDebitNote: customMessages,
      };
    }
    if (entityType === 'GOOD_RECEIVING_NOTES') {
      return {
        ...state,
        customMessageGoodReceivingNotes: customMessages,
      };
    }
    if (entityType === 'PURCHASE_ORDERS') {
      return {
        ...state,
        customMessagePurchaseOrders: customMessages,
      };
    }
    if (entityType === 'PURCHASE_REQUEST') {
      return {
        ...state,
        customMessagePurchaseRequest: customMessages,
      };
    }
    if (entityType === 'CREDIT_NOTE') {
      return {
        ...state,
        customMessageCreditNote: customMessages,
      };
    }
    if (entityType === 'CUSTOMERS') {
      return {
        ...state,
        customMessagecustomers: customMessages,
      };
    }
    if (entityType === 'INVOICE') {
      return {
        ...state,
        customMessageInvoice: customMessages,

      };
    }
  }
  case cmActionTypes.CREATE_CM.LOADING: {
    const { createCMLoading } = action;
    return {
      ...state,
      createCMLoading,
    };
  }
  case cmActionTypes.UPDATE_CM.LOADING: {
    const { updateCMLoading } = action;
    return {
      ...state,
      updateCMLoading,
    };
  }
  case cmActionTypes.DELETE_CM.LOADING: {
    const { deleteCMLoading } = action;
    return {
      ...state,
      deleteCMLoading,
    };
  }

  default: {
    return state;
  }
  }
};

export default CMReducers;
